// Copyright (C) Siemens AG 2026. All rights reserved. Confidential
import { PortalUser } from "./platformuser.model";

export class SubTenant {
    id: number;
    name: string;
    pricingPlanKey: string | null;
    pricingPlanId: number | null;
    creditLimit: number | null = null;
    remainingCreditLimit: number | null = null;
    copyParentPricingPlan: boolean = false;
    firstUser!: {email: string, firstName: string, lastName: string};

    constructor(id: number, name: string, pricingPlanKey: string | null = null, creditLimit: number | null = null, copyParentPricingPlan: boolean = false, pricingPlanId: number | null = null) {
        this.id = id;
        this.name = name;
        this.pricingPlanKey = pricingPlanKey;
        this.pricingPlanId = pricingPlanId;
        this.creditLimit = creditLimit;
        this.copyParentPricingPlan = copyParentPricingPlan;
    }

    toCreationAPIForm(user: PortalUser): any {
        const payload: any = {
            name: this.name,
            userEmail: user.email,
            userFirstName: user.firstName,
            userLastName: user.lastName,
        };
        
        // Add conditional fields based on backend requirements
        if (this.pricingPlanKey) {
            payload.pricingPlanKey = this.pricingPlanKey;
        }
        if (this.copyParentPricingPlan) {
            payload.copyParentPricingPlan = this.copyParentPricingPlan;
        }
        if (this.creditLimit !== null) {
            payload.creditLimit = this.creditLimit;
        }
        
        return payload;
    }

    public static FromAPI(apiData: any) {
        const mappedPricingPlanKey = apiData.pricingPlanKey ?? apiData.plankey ?? apiData.pricingplan_key ?? apiData.pricingplanKey ?? null;
        const mappedPricingPlanId = apiData.pricingPlanId ?? apiData.pricingplan_id ?? apiData.pricingplanId ?? null;
        const st = new SubTenant(
            apiData.id,
            apiData.name,
            mappedPricingPlanKey,
            apiData.creditLimit ?? null,
            apiData.copyParentPricingPlan ?? false,
            mappedPricingPlanId
        );
        st.remainingCreditLimit = apiData.remainingCreditLimit ?? null;
        return st;
    }
}
